import type { FuncionProjectSpec } from "../data/funciones/spec";
import type { TaskResult } from "../types";

type StartFunction = () => Promise<void>;
type GradeFunction = () => Promise<TaskResult[]>;

type StartModule = { [key: string]: StartFunction };
type GradeModule = { [key: string]: GradeFunction };

const startFunctionLoaders: Record<string, () => Promise<StartFunction>> = {
  project1: () => import("../excel/project1.excel").then((m: StartModule) => m.startProject1),
  project2: () => import("../excel/project2.excel").then((m: StartModule) => m.startProject2),
  project3: () => import("../excel/project3.excel").then((m: StartModule) => m.startProject3),
  project4: () => import("../excel/project4.excel").then((m: StartModule) => m.startProject4),
  project5: () => import("../excel/project5.excel").then((m: StartModule) => m.startProject5),
  project6: () => import("../excel/project6.excel").then((m: StartModule) => m.startProject6),
  project7: () => import("../excel/project7.excel").then((m: StartModule) => m.startProject7),
  project8: () => import("../excel/project8.excel").then((m: StartModule) => m.startProject8),
  project9: () => import("../excel/project9.excel").then((m: StartModule) => m.startProject9),
  project10: () => import("../excel/project10.excel").then((m: StartModule) => m.startProject10),
  project11: () => import("../excel/project11.excel").then((m: StartModule) => m.startProject11),
  project12: () => import("../excel/project12.excel").then((m: StartModule) => m.startProject12),
  project13: () => import("../excel/project13.excel").then((m: StartModule) => m.startProject13),
  project14: () => import("../excel/project14.excel").then((m: StartModule) => m.startProject14),
  project15: () => import("../excel/project15.excel").then((m: StartModule) => m.startProject15),
  project16: () => import("../excel/project16.excel").then((m: StartModule) => m.startProject16),
  project17: () => import("../excel/project17.excel").then((m: StartModule) => m.startProject17),
  project18: () => import("../excel/project18.excel").then((m: StartModule) => m.startProject18),
  project19: () => import("../excel/project19.excel").then((m: StartModule) => m.startProject19),
  project20: () => import("../excel/project20.excel").then((m: StartModule) => m.startProject20),
  project21: () => import("../excel/project21.excel").then((m: StartModule) => m.startProject21),
  project22: () => import("../excel/project22.excel").then((m: StartModule) => m.startProject22),
  project23: () => import("../excel/project23.excel").then((m: StartModule) => m.startProject23),
  "funciones-buscarx": () =>
    import("../excel/funciones-buscarx.excel").then((m: StartModule) => m.startFuncionesBuscarx),
};

const gradeFunctionLoaders: Record<string, () => Promise<GradeFunction>> = {
  project1: () => import("./project1.grading").then((m: GradeModule) => m.gradeProject1),
  project2: () => import("./project2.grading").then((m: GradeModule) => m.gradeProject2),
  project3: () => import("./project3.grading").then((m: GradeModule) => m.gradeProject3),
  project4: () => import("./project4.grading").then((m: GradeModule) => m.gradeProject4),
  project5: () => import("./project5.grading").then((m: GradeModule) => m.gradeProject5),
  project6: () => import("./project6.grading").then((m: GradeModule) => m.gradeProject6),
  project7: () => import("./project7.grading").then((m: GradeModule) => m.gradeProject7),
  project8: () => import("./project8.grading").then((m: GradeModule) => m.gradeProject8),
  project9: () => import("./project9.grading").then((m: GradeModule) => m.gradeProject9),
  project10: () => import("./project10.grading").then((m: GradeModule) => m.gradeProject10),
  project11: () => import("./project11.grading").then((m: GradeModule) => m.gradeProject11),
  project12: () => import("./project12.grading").then((m: GradeModule) => m.gradeProject12),
  project13: () => import("./project13.grading").then((m: GradeModule) => m.gradeProject13),
  project14: () => import("./project14.grading").then((m: GradeModule) => m.gradeProject14),
  project15: () => import("./project15.grading").then((m: GradeModule) => m.gradeProject15),
  project16: () => import("./project16.grading").then((m: GradeModule) => m.gradeProject16),
  project17: () => import("./project17.grading").then((m: GradeModule) => m.gradeProject17),
  project18: () => import("./project18.grading").then((m: GradeModule) => m.gradeProject18),
  project19: () => import("./project19.grading").then((m: GradeModule) => m.gradeProject19),
  project20: () => import("./project20.grading").then((m: GradeModule) => m.gradeProject20),
  project21: () => import("./project21.grading").then((m: GradeModule) => m.gradeProject21),
  project22: () => import("./project22.grading").then((m: GradeModule) => m.gradeProject22),
  project23: () => import("./project23.grading").then((m: GradeModule) => m.gradeProject23),
  "funciones-buscarx": () =>
    import("./funciones-buscarx.grading").then((m: GradeModule) => m.gradeFuncionesBuscarx),
};

/**
 * Funciones projects described by a spec: one generic builder and one
 * generic grader serve all of them. Add a project here and in PROJECT_SHEETS.
 */
const specLoaders: Record<string, () => Promise<FuncionProjectSpec>> = {
  "funciones-si": () => import("../data/funciones/logicas/si").then((m) => m.spec),
  "funciones-y-o-no": () => import("../data/funciones/logicas/y-o-no").then((m) => m.spec),
  "funciones-si-conjunto": () =>
    import("../data/funciones/logicas/si-conjunto").then((m) => m.spec),
  "funciones-si-error": () => import("../data/funciones/logicas/si-error").then((m) => m.spec),
  "funciones-es-validacion": () =>
    import("../data/funciones/logicas/es-validacion").then((m) => m.spec),
  "funciones-anidadas": () => import("../data/funciones/logicas/anidadas").then((m) => m.spec),
  "funciones-sumarsiconjunto": () =>
    import("../data/funciones/agregacion/sumar-si-conjunto").then((m) => m.spec),
  "funciones-contarsiconjunto": () =>
    import("../data/funciones/agregacion/contar-si-conjunto").then((m) => m.spec),
  "funciones-promediosiconjunto": () =>
    import("../data/funciones/agregacion/promedio-si-conjunto").then((m) => m.spec),
  "funciones-tablero-agregacion": () =>
    import("../data/funciones/agregacion/tablero").then((m) => m.spec),
  "funciones-buscarv": () => import("../data/funciones/busqueda/buscarv").then((m) => m.spec),
  "funciones-indice-coincidir": () =>
    import("../data/funciones/busqueda/indice-coincidir").then((m) => m.spec),
  "funciones-coincidirx": () => import("../data/funciones/busqueda/coincidirx").then((m) => m.spec),
  "funciones-cotizador": () => import("../data/funciones/busqueda/cotizador").then((m) => m.spec),
  "funciones-extraer": () => import("../data/funciones/texto/extraer").then((m) => m.spec),
  "funciones-limpiar": () => import("../data/funciones/texto/limpiar").then((m) => m.spec),
  "funciones-antes-despues": () =>
    import("../data/funciones/texto/antes-despues").then((m) => m.spec),
  "funciones-dividir": () => import("../data/funciones/texto/dividir").then((m) => m.spec),
  "funciones-erp": () => import("../data/funciones/texto/erp").then((m) => m.spec),
  "funciones-componentes-fecha": () =>
    import("../data/funciones/fechas/componentes").then((m) => m.spec),
  "funciones-contratos": () => import("../data/funciones/fechas/contratos").then((m) => m.spec),
  "funciones-antiguedad": () => import("../data/funciones/fechas/antiguedad").then((m) => m.spec),
  "funciones-dias-habiles": () => import("../data/funciones/fechas/dias-habiles").then((m) => m.spec),
  "funciones-turnos": () => import("../data/funciones/fechas/turnos").then((m) => m.spec),
  "funciones-redondeo": () => import("../data/funciones/matematicas/redondeo").then((m) => m.spec),
  "funciones-sumaproducto": () =>
    import("../data/funciones/matematicas/sumaproducto").then((m) => m.spec),
  "funciones-estadistica": () =>
    import("../data/funciones/matematicas/estadistica-salarios").then((m) => m.spec),
  "funciones-jerarquia": () => import("../data/funciones/matematicas/jerarquia").then((m) => m.spec),
  "funciones-proveedores": () => import("../data/funciones/matematicas/proveedores").then((m) => m.spec),
  "funciones-elegir": () => import("../data/funciones/avanzadas/elegir").then((m) => m.spec),
  "funciones-tomar": () => import("../data/funciones/avanzadas/tomar").then((m) => m.spec),
  "funciones-apilar": () => import("../data/funciones/avanzadas/apilar").then((m) => m.spec),
  "funciones-encol": () => import("../data/funciones/avanzadas/encol").then((m) => m.spec),
  "funciones-reporte-trimestral": () =>
    import("../data/funciones/avanzadas/reporte-trimestral").then((m) => m.spec),
  "funciones-filtrar": () => import("../data/funciones/matrices/filtrar").then((m) => m.spec),
  "funciones-unicos": () => import("../data/funciones/matrices/unicos").then((m) => m.spec),
  "funciones-ordenar": () => import("../data/funciones/matrices/ordenar").then((m) => m.spec),
  "funciones-secuencia": () => import("../data/funciones/matrices/secuencia").then((m) => m.spec),
  "funciones-reporte-matrices": () =>
    import("../data/funciones/matrices/reporte").then((m) => m.spec),
};

export async function getStartFunction(
  projectId: string
): Promise<StartFunction | null> {
  const specLoader = specLoaders[projectId];
  if (specLoader) {
    const [spec, builder] = await Promise.all([
      specLoader(),
      import("../excel/funcionesBuilder"),
    ]);
    return () => builder.buildFuncionProject(spec);
  }

  const loader = startFunctionLoaders[projectId];
  if (!loader) return null;
  return loader();
}

export async function getGradeFunction(
  projectId: string
): Promise<GradeFunction | null> {
  const specLoader = specLoaders[projectId];
  if (specLoader) {
    const [spec, grader] = await Promise.all([specLoader(), import("./funcionesGrader")]);
    return () => grader.gradeFuncionProject(spec);
  }

  const loader = gradeFunctionLoaders[projectId];
  if (!loader) return null;
  return loader();
}
